import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react"
// import { NotificationContext } from "../contextProviders/notificationContext"
import { useUserContext } from "../contextProviders/userContext"
import { PhotoManagerContext } from "../contextProviders/photoManagerContext"
// import { DiagnosticsContext } from "../contextProviders/diagnosticsContext"
import { useNavigate, useLocation, useHistory } from "react-router-dom"
import packageJson from '../../../../package.json'
import { dataSource } from "../../../services/dataSource"
import { REP, REP_V2 } from "../../../shared/Data/typeDirs"
import { AllReportsContext } from "../contextProviders/allReportsContext"
import { unlockReportBlocksByUser } from "../../../services/networkRequests"

const {version, build} = packageJson
const AppContainerContextClass = createContext(null)

export function AppContainerContext({ children }) {
  const [menuOptions, setMenuOptions] = useState([])
  const [title, setTitle] = useState([])
  const [navi, setNavi] = useState()
  const [header, setHeader] = useState([])
  const [progress, setProgress] = useState([])
  const [progressMessage, setProgressMessage] = useState([])
  const [isDragging, setIsDragging] = useState(false)
  const [isSidebarOpen, setIsSidebarOpen ] = useState(false)
  const [selectedTextForSidebar, setSelectedTextForSidebar ] = useState('')
  const [selectedFieldName, setSelectedFieldName] = useState('');
  // Add state for the apply callback/ref
  const [applyChatResponseTarget, setApplyChatResponseTarget] = useState(null)
  const navigate = useNavigate()
  const location = useLocation()
  let [history, setHistory ]= useState([])
  // const history = useHistory()
  const { user } = useUserContext()
  function clearGenericContainers() {
    setNavi(false)
    setHeader([])
    setProgress(false)
  }

  const childSetTitle = useCallback((newTitle)=>{
    const postfix = `| ${packageJson.build.productName} ${packageJson.version}`
    window.document.title = `LCS Recaapp | ${newTitle}`
    setTitle(newTitle)
  }, [setTitle])

  const childSetMenuOptions = useCallback((_menuOptions = []) => {
    setMenuOptions(_menuOptions)
  }, [navigate, setMenuOptions])

  useEffect(() => {
    if (history[1] && history[1].pathname.includes(REP_V2)) {
      const report_id = history[1].pathname.split('/')[2]
      console.log('unlocking report blocks for user', report_id)
      unlockReportBlocksByUser(report_id, user.token)
    }
  }, [history])

  // console.log('reloading appcontainer context', header)
  // const [currentHistoryPath, previousHistoryPath] = useMemo(()=>{
  //   return[ location.pathname, location.pathname]
  // })

  useEffect(()=>{
    setHistory([location, ...history].slice(0, 2))
    console.log('history logged', history)
  }, [location])


  return (
    <AppContainerContextClass.Provider value={{
      menuOptions, setMenuOptions: childSetMenuOptions,
      title, setTitle: childSetTitle,
      navi, setNavi,
      header, setHeader,
      progress, setProgress,
      progressMessage, setProgressMessage,
      clearGenericContainers,
      isDragging, setIsDragging,
      isSidebarOpen, setIsSidebarOpen,
      selectedTextForSidebar, setSelectedTextForSidebar,
      applyChatResponseTarget, setApplyChatResponseTarget,
      selectedFieldName, setSelectedFieldName
    }}>
      <PhotoManagerContext setMessage={setProgressMessage} setProgress={setProgress}>

        <AllReportsContext>
          {children}

        </AllReportsContext>
      </PhotoManagerContext>
    </AppContainerContextClass.Provider>


  )
}

export function useAppContainerContext() {
  return useContext(AppContainerContextClass)
}

async function unlockReport(previousHistoryPath, user) {
  //if previous page was /reports unlock report
  let isReportLocked = await dataSource('remDb')[REP].checkLock({ _id: previousHistoryPath.split('/')[2] })
  console.log('report locked status after leaving report page', isReportLocked, user)
  if (isReportLocked.locked !== user.username) return false
  return dataSource('remDb')[REP].unlock({ _id: isReportLocked._id })
}
